import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { usePortalAuth } from "./PortalAuthContext";

export function PortalProtectedRoute() {
  const { account, loading } = usePortalAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="d-flex align-items-center justify-content-center vh-100">
        <span className="text-secondary">Carregando…</span>
      </div>
    );
  }

  if (!account) {
    return <Navigate to="/portal/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
